@if (usersToDisplay) {
  <div class="row users-list">
    <div class="col-12 col-md-auto d-flex flex-wrap">
      @for (user of usersToDisplay; track user[$user._id]; let i = $index) {
        <div class="position-relative">
          <img
            tabindex="0"
            [src]="getUserAvatarUrl(user)"
            class="user-profile-picture"
            alt="{{ getDisplayName(user) + ' ' + ('user_profile_avatar' | translate) }}"
            [ngbTooltip]="getDisplayName(user)"
            [container]="'body'"
          />
        </div>
      }
      @if (hiddenUsers && usersCount > maxDisplayedUsers) {
        <div class="position-relative">
          <button
            class="btn btn-link extra-users-count"
            #buttonElement
            [triggers]="'click'"
            [container]="'body'"
            popoverClass="popover-height-100"
            (hidden)="buttonElement.focus()"
            (shown)="focusUsersListPopover()"
            [autoClose]="'outside'"
            [ngbPopover]="hiddenUsersContainer"
            [attr.aria-label]="'+' + hiddenUsers.length + ' ' + ('users' | translate | lowercase)"
          >
            <span>+{{ hiddenUsers.length }}</span>
          </button>
        </div>
      }
    </div>
  </div>
}

<ng-template #hiddenUsersContainer>
  @for (user of hiddenUsers; track user[$user._id]; let i = $index) {
    <div class="d-flex" [tabIndex]="i">
      <img
        class="user-profile-picture"
        [src]="getUserAvatarUrl(user)"
        title="{{ getDisplayName(user) }}"
        aria-hidden="true"
        alt="{{ getDisplayName(user) + ' ' + ('user_profile_avatar' | translate) }}"
      />
      <span class="user-name">{{ getDisplayName(user) }}</span>
    </div>
  }
</ng-template>
